import styled from 'styled-components';
import { Typography } from '@visionplanner/ui-react-material';

const StyledNotFound = styled.div`
    color: ${({ theme }) => theme.colors.eastBay};
    img {
      margin-top: 100px;
    }
    .mdc-typography--headline1 {
      font-size: 9.75rem;
    }
    .mdc-typography--headline2 {
      font-size: ${({ theme }) => theme.fontSizes.fs42};
    }
`;

const NotFound = () => (
  <StyledNotFound className="flex-column align-items-center flex-relative-size-one">
    <img src="/assets/images/404.png" alt="not-found" />
    <Typography use="h1" className="mar-ver-lg">404</Typography>
    <Typography use="h2" className="mar-ver-lg">Page not found</Typography>
  </StyledNotFound>
);

export default NotFound;
